import type { Permission, Teammate } from "@/features/teammates/types";

const checkUserPermissions = (
  userDetails: Teammate | undefined,
  requiredPermissions: Permission[],
  consentSolutionId?: number | string,
): boolean => {
  if (!userDetails) return false;

  const requiredPermissionsList = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];

  const globalPermissions = userDetails.globalPermissions || [];
  const csId = consentSolutionId ? Number(consentSolutionId) : undefined;
  const resourcePermissions =
    csId && userDetails.resourcePermissions
      ? userDetails.resourcePermissions.find((resource) => resource.resourceId === csId)?.permissions || []
      : [];

  const userPermissionsList = [...globalPermissions, ...resourcePermissions];

  return requiredPermissionsList.every((permission) => userPermissionsList.includes(permission));
};

export { checkUserPermissions };
